import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static scrollToTop() {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }

  toTop() {
    this.constructor.scrollToTop();
  }
}
